/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IArticleDetailsViewProps } from './article-details';

export default (props: IArticleDetailsViewProps) => {
    return (
        <>
            <h2 className={props.config.className}>Details</h2>

            <p>Article: {props.productId}</p>
            <p>{props.modelInfo}</p>
        </>
    );
};
